import React from 'react';
import image from '../../../main/view/add-item/select-item-type-modal/content/type-selectors/link/assets/link.svg';
import ImageHeader from '../image-header/index.tsx';

const Header = () => <ImageHeader src={image} />;

export default Header;
